import React from "react";
import { Table } from "reactstrap";
import { FormattedNumber } from "../../../FormattedNumber/FormattedNumber";

import style from "../Grid.module.scss";

const TransactionAccounts = ({ accounts, showCurrency }) => (
  <div className={style.grid}>
    <h6 className="my-3">Accounts</h6>
    <Table responsive hover>
      <thead>
        <tr>
          <th>Account</th>
          {showCurrency && (
            <React.Fragment>
              <th>Currency</th>
              <th className="text-right">Amount</th>
            </React.Fragment>
          )}
        </tr>
      </thead>
      <tbody>
        {accounts.map((item) => (
          <tr key={item.ItemId}>
            <td>{item.Name}</td>
            {showCurrency && (
              <React.Fragment>
                <td>{item.CurrencyIso}</td>
                <td className="text-right">
                  <FormattedNumber value={item.Amount} dataTypeDecimalName="currency" />
                </td>
              </React.Fragment>
            )}
          </tr>
        ))}
        {accounts.length === 0 && (
          <tr>
            <td colSpan={8} style={{ textAlign: "center" }}>
              No Accounts
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  </div>
);

export default TransactionAccounts;
